import React, { useState, useRef, useEffect } from "react";
import { GiHamburgerMenu as GiHamburgerMenuIcon } from "react-icons/gi";

import NewModal from "../../../NewModal";
import BodyModalChat from "../../../NewModal/BodyModalChat";
import Sidebar from "./SideBar";
import MenuLinkItem from "./MenuLinkItem";
import { ButtonPrimary } from "../../../common/Buttons/Button";

import { ReactComponent as LogoImg } from "../../../../assets/images/csh-logo-bg-neutral.svg";
import { ReactComponent as ChatIcon } from "../../../../assets/images/icons/chat-icon.svg";

import { links, chatButtons } from "../../../../config";
import { menuLinks } from "./Constants/ConstantsMenuList";

import * as S from "./Header.Style";

const Header = () => {
  const [isOpenMenu, setIsOpenMenu] = useState(false);
  const [isOpenSubmenu, setIsOpenSubmenu] = useState(false);
  const [isModalChatOpen, setIsModalChatOpen] = useState(false);
  const [activeItem, setActiveItem] = useState(null);
  const [submenuHeight, setSubmenuHeight] = useState(0);

  const submenuRef = useRef(null);

  const handleMouseEnter = (label) => {
    setIsOpenSubmenu(label);
  };

  const handleMouseLeave = () => {
    setIsOpenSubmenu(null);
  };

  const handleToggleChat = () => {
    setIsModalChatOpen((state) => !state);
  };

  const handleToggle = () => {
    setIsOpenMenu((state) => !state);
  };

  useEffect(() => {
    if (submenuRef.current && isOpenSubmenu) {
      setSubmenuHeight(submenuRef.current.clientHeight);
    } else {
      setSubmenuHeight(0);
    }
  }, [isOpenMenu, isOpenSubmenu, submenuHeight]);

  return (
    <>
      <S.HeaderContainer>
        <S.HeaderContent>
          <S.LogoContainer href="/" className="logo">
            <LogoImg />
          </S.LogoContainer>

          <nav>
            <S.LinksList>
              {menuLinks
                .filter((menuLink) => !menuLink?.isOnlyMobile)
                .map((menuLink, index) => {
                  const isShowSubmenu =
                    Array.isArray(menuLink?.submenu) &&
                    menuLink.label === isOpenSubmenu;

                  return (
                    <S.LinksItem
                      key={`${menuLink.label}-${index}-desktop`}
                      onMouseLeave={handleMouseLeave}
                      onMouseEnter={() => handleMouseEnter(menuLink.label)}
                    >
                      <MenuLinkItem menuLink={menuLink} />

                      {/* Dropdown */}
                      {isShowSubmenu && (
                        <>
                          <S.SubmenuBackground
                            className="submenu-bg"
                            style={{ height: `${submenuHeight + 30}px` }}
                          />
                          <S.SubmenuContainer className="submenu">
                            <S.SubmenuLinksList ref={submenuRef}>
                              {menuLink.submenu.map((sublink, submenuIndex) => (
                                <React.Fragment
                                  key={`${sublink.label}-${submenuIndex}-submenu`}
                                >
                                  {sublink.isDivider ? (
                                    <S.Divider />
                                  ) : (
                                    <S.SubmenuLinksItem>
                                      <MenuLinkItem
                                        menuLink={sublink}
                                        isEnableActiveClass={false}
                                      />
                                    </S.SubmenuLinksItem>
                                  )}
                                </React.Fragment>
                              ))}
                            </S.SubmenuLinksList>
                          </S.SubmenuContainer>
                        </>
                      )}
                    </S.LinksItem>
                  );
                })}
            </S.LinksList>
          </nav>

          <S.ActionsContainer>
            <GiHamburgerMenuIcon className="hamburger" onClick={handleToggle} />
            <ChatIcon
              id="chat-button"
              width="28px"
              height="28px"
              onClick={handleToggleChat}
            />
            <S.LoginButton href={links.areaLogada} as={ButtonPrimary}>
              Login
            </S.LoginButton>
          </S.ActionsContainer>
        </S.HeaderContent>
      </S.HeaderContainer>

      {/* Mobile */}
      <Sidebar isOpenMenu={isOpenMenu} onToggle={handleToggle} />

      {/* Chat modal */}
      <NewModal
        show={isModalChatOpen}
        onToggle={setIsModalChatOpen}
        closeHandle={isModalChatOpen}
        titleModal="Chat"
        subTitleModal={
          activeItem === null ? "Escolha sobre qual seguro quer falar." : null
        }
        icon={<ChatIcon />}
      >
        <BodyModalChat
          itemChat={chatButtons}
          showModal={isModalChatOpen}
          activeItem={activeItem}
          setActiveItem={setActiveItem}
        />
      </NewModal>
    </>
  );
};

export default Header;
